module.exports = __webpack_public_path__ + "static/media/CENTRO-DE-SERVICIO.2a2f8df8.mp4";